import { Box } from "@mui/material";
import React from "react";
import WithLove from "../../common/components/WithLove";
// import dayOne from "../../images/day1.png";
// import creation from "../../images/creation.png";
import Topic from "../../common/components/Topic";
import Picture from "../../common/components/Picture";
import Title from "../../common/components/Title";
import Content from "../../common/components/Content";
import Subtitle from "../../common/components/Subtitle";
import Text from "../../common/components/Text";
import SubSection from "../../common/components/SubSection";
import Section from "../../common/components/Section";
// import Number from "../../common/components/Number";

// Images Import

import cover from "../../images/4.0/day1/Cover Image.jpg";
import corruptible from "../../images/4.0/day1/1 corruptible seed.jpg";
import incorruptible from "../../images/4.0/day1/3. The Incorruptible Seed.jpg";
import bornOfIncorruptible from "../../images/4.0/day1/4. Adam was made to be born of the incorruptible seed.jpg";
import corruption from "../../images/4.0/day1/5. The fall of man into corruption on his way to the corruptible.jpg";
import jesus from "../../images/4.0/day1/6. Jesus Came to Stop Corruption and Make Man Incorruptible..jpg";
import church from "../../images/4.0/day1/7. The Church to Make Man Incorruptible.jpg";
import mmsm from "../../images/4.0/day1/8. Milk, Meat, and the Strong Meat.jpg";
import principles from "../../images/4.0/day1/9. Milk The first principles of the oracles of God.png";
import fruit from "../../images/4.0/day1/10. The fruit of the milk in the soul.jpg";
import limitations from "../../images/4.0/day1/11. Limitations of the milk..jpg";

export default function FourDayOne() {
  return (
    <>
      <Box>
        <Topic>
          An Introduction to the Corruptible seed and the Incorruptible seed
        </Topic>
        <Text>1 Peter 1:23, 1 John 3:9, 1 Peter 1:4, 1 Corinthians 9:25.</Text>
        <br />
      </Box>
      <Picture src={cover} />
      <Section>
        <Section>
          <Title>Introduction </Title>
          <Content>
            {/* You are welcome to <b>Gadites Bible Seminar 4.0</b>.
            <br />
            <br /> */}
            We thank God for another year of Gadites Bible Seminar. The Lord has
            led us from the unity of the faith to the present economy of God,
            after which God dealt with us according to the everlasting kingdom
            and now God is emphasizing that he wants to raise us as an
            incorruptible generation.
            <br />
            <br />
            We trust God for grace to explore the mind of the Spirit that we all
            may carry this vision and burden in our hearts to accomplish the
            desire of Jesus Christ for us as a generation.
          </Content>
        </Section>
        <br />
        <Section>
          <Title>The Corruptible Seed</Title>
          <br />
          <Picture src={corruptible} />
          <br />
          <Content>
            The word &#8220;corrupt&#8221; (from the Greek word shachath: which
            means to decay; to destroy; to degenerate; to corrode; to perish)
            was first used to describe an activity that occurred in an angel (a
            cherub called Lucifer), even before the creation of man{" "}
            <b>(Eze. 28:17, Gen 1:26).</b> Lucifer was full of wisdom and
            perfect in beauty. However, being lifted up because of his beauty,
            he perverted the wisdom in him, thereby inventing the corruptible
            life <b>(Eze. 28:12-18).</b>
            <br />
            <br />
            The corruptible life is a nature of total destruction, which makes a
            creature eternally separated from God (John 10:10, Hebrews 2:14). .
            This nature is the fruit of a seed which the scripture calls the
            corruptible seed <b>(1 Pet 1:23).</b>
            This nature was also found amongst the angels who Satan successfully
            birthed by the corruptible seed <b>(Jude 1:6, Eph 6:12). </b>
            According to Luke 8:11 and 1 Pet 1:23, seed can be likened to word.
            Therefore, we can conclude that the corruptible seed is the word
            that contains all the genes of Satan.
          </Content>
        </Section>
        <br />
        <Section>
          <Title>
            The Incorruptible Seed (1 Peter 1:3-5, 1 Peter 1:23, 2 Timothy 1:10)
          </Title>
          <br />
          <Picture src={incorruptible} />
          <br />
          <Content>
            The word &#8220;Incorruptible&#8221; (from the Greek word
            aphthartos: which means undecaying, unfading, immortal,
            imperishable) describes the quality of life in the Father{" "}
            <b>(James 1:17, Rom 1:23, Malachi 3:6).</b> It means to be immune
            from corruption or any form of decadence. The life found with the
            angels is the finest of this present creation <b>(Psalm 103:20),</b>{" "}
            but when Lucifer sinned, it became clear that even the angelic life
            was not incorruptible.
            <br />
            <br />
            God created the heavens and the earth in the beginning to last{" "}
            <b>(Psalm 89:29),</b> but owing to the outbreak of sin in creation,
            the heaven and earth are gradually passing away showing that they
            are not incorruptible{" "}
            <b> (Hebrews 1:10-12, 2 Pet 3:10-12, Matt 5:18). </b> The
            incorruptible life is a quality of life that is exclusive to God{" "}
            <b>
              (Romans 1:23, Malachi 3:6, James 1:17, Numbers 23:19, Mark 10:18).{" "}
            </b>{" "}
            Therefore, if any man must be made incorruptible, such a person must
            be born of God, through the incorruptible seed (or word) of God{" "}
            <b>(James 1:18, 1 Pet 1:23, 1 John 3:9).</b> The incorruptible seed
            is God’s means of birthing the incorruptible nature in a being.
          </Content>
        </Section>
        <br />
        <Section>
          <Title>
            Adam was made to be born of the incorruptible seed (Genesis 1:26-27)
          </Title>
          <br />
          <Picture src={bornOfIncorruptible} />
          <br />
          <Content>
            We have seen that everything God created in the beginning was good
            (void of corruption), including man. It is good to note that
            although Adam was made a living soul, he was not immune from
            corruption as he could still die <b>(Gen 2:15-17).</b> God’s
            intention was for him to partake of the incorruptible nature in God.
            For Adam to move into the incorruptible life, he also had to be born
            of God, by the incorruptible seed. God’s provision in achieving this
            was through His voice <b>(James 1:18, Genesis 3:8, Psalm 8:4).</b>
            <br />
            <br />
            However, Adam ate of the tree of the knowledge of good and evil,
            thereby giving room for the corruptible seed to enter into the human
            race. By this, mankind began a gradual degeneration towards the
            corruptible nature <b>(Romans 6:19).</b>
          </Content>
        </Section>
        <br />
        <Section>
          <Title>
            The fall of man into corruption on his way to the corruptible
          </Title>
          <br />
          <Picture src={corruption} />
          <br />
          <Content>
            Just like in the natural, a seed requires a conducive environment to
            germinate; thus, to be born of the corruptible seed, a suitable
            heart nature is also required <b>(Matt 13:3-8).</b> This heart
            nature is an age, maturity or wisdom required to unlock the wisdom
            of the corruptible life. The scriptures describe this maturity as an
            ungodly or a sensual estate{" "}
            <b>(James 3:15, Psalm 1:4-6, Tit 2:12, Jude 18-19).</b>
            <br />
            <br />
            Adam did not have this nature that could develop the corruptible
            seed. However, the seed began to prepare the man to be fertile
            enough to germinate its life. This preparation is a process of
            corruption <b>(1 Tim 6:5-6, 2 Tim 3:8).</b> This was obvious in that
            their eyes were opened, they knew they were naked and sew fig leaves
            to cover themselves; an action alien to their previous conversation{" "}
            <b>(Gen 3:7).</b> Mercifully, God intervened to intercept this
            process of corruption by clothing Adam and Eve with coats of skins,{" "}
            <b>(Gen 3:21).</b>
            <br />
            <br />
            Although Adam and Eve did not continue in corruption, mankind over
            the ages journeyed in corruption with some men (Cain, Nimrod, Sodom
            and Gomorrah etc.) going on to be born of the corruptible seed{" "}
            <b>(1 John 3:12, Genesis 10:8-9).</b> However, God in mercy
            prevented the corruptible seed from birthing the entire human race
            as in the season of the flood <b>(Gen 6),</b> the tower of Babel{" "}
            <b>(Gen 11),</b> and Sodom and Gomorrah <b>(Gen 19).</b>
          </Content>
        </Section>
        <br />
        <Section>
          <Title>
            Jesus Came to Stop Corruption and Make Man Incorruptible.
          </Title>
          <br />
          <Picture src={jesus} />
          <br />
          <Content>
            It is good to note that man is a spirit, he has soul, and lives in a
            body <b>(1 Thess. 5:23).</b> When man ate of the tree, his spirit
            died instantly, and the corruptible seed entered into his soul,
            initiating a journey of corruption towards the corruptible nature,
            affecting the body <b>(Eph 2:1-3).</b> Though God had been limiting
            the progress of corruption and the corruptible seed on the earth in
            different ages, mankind continued in corruption, becoming worldly
            and ungodly ready to perish <b>(Rom 5:6).</b>
            <br />
            <br />
            As a final solution, God sent Jesus not just to stop corruption but
            to make man incorruptible <b>(John 3:16).</b> By the reason of
            Jesus’ death, burial, and resurrection, the provision of the new
            birth is made available to everyone who believes. At the new birth,
            the spirit is quickened while the soul and body are purchased and
            added to the church for the purpose of attaining incorruption{" "}
            <b>
              (1 Cor. 15:1-3; Eph 2:1; Eph 1:14; 1 Cor. 6:20; Acts 2:41, 47;
              Acts 20:28, 1 Pet 1:3, Eph 1:14).
            </b>
          </Content>
        </Section>
        <br />
        <Section>
          <Title>The Church is to Make Man Incorruptible</Title>
          <br />
          <Picture src={church} />
          <br />
          <Content>
            We see from scriptures that being born again is to the end of
            becoming incorruptible, undefiled, and unfading, which Peter
            described as salvation <b>(1 Peter 1:3-5).</b> Thus, the essence of
            the church is to make the soul of believers immune to corruption or
            saved <b>(Acts 2:47, 1 Peter 1:4, 9).</b>
            <br />
            <br />
            Jesus instituted the church for the purpose of making saints
            indestructible <b>(Matthew 16:18).</b> Hence, the purpose of being a
            member of the church of our Lord Jesus Christ is to attain the
            incorruptible nature of God. God’s technology of bringing the soul
            to this estate is feeding. Thus, the responsibility of the church is
            to feed the soul till it becomes incorruptible{" "}
            <b>(Acts 20:28, 1 Peter 5:2).</b>
            <br />
            <br />
            It is also good to note that incorruptibility cannot be obtained in
            isolation or outside the church{" "}
            <b>(Hebrews 10:25, Psalms 133:1-3);</b> it can only be conveyed
            through the preaching and teaching of the word by ministers God has
            equipped <b>(Ephesians 4:10-14).</b>
            <br />
            <br />
            There are three allocations of feeding given to the church to attain
            incorruption. These include the Milk, The Meat, and the Strong meat
            of the word <b>(Hebrews 5:13-14, 1 Corinthians 3:1-2).</b>
          </Content>
        </Section>
        <br />
        <Section>
          <Title>Milk, Meat, Strong meat</Title>

          <br />
          <Picture src={mmsm} />
          <br />
          <Content>
            As was earlier established, feeding is the receiving of the
            knowledge and doctrine of God. 1 Cor. 3:1-2, in describing different
            allocations of the word, shows that there is such thing as milk and
            such thing as meat. Heb. 5:12 introduces strong meat, which
            logically implies a level of the word higher than meat. We can thus
            conclude from scriptures, the existence of these meals - milk, meat,
            and strong meat.
            <br />
            <br />
            From Heb. 5:12-14, 6:1, we can see that the first principle of the
            oracles of God, or the foundation, is milk; the principles of the
            doctrine of Christ is meat, and the word of righteousness is strong
            meat. A believer who uses meat is skillful in the word of
            righteousness, but one who uses milk is not.
            <br />
            <br />
            What gives full age is meat. The meat will raise a stature that can
            participate in the judgment of discerning good and evil. Good is the
            incorruptible seed, and evil is the corruptible seed{" "}
            <b>(1 Peter 1:23).</b>An allegory of these meals is seen in what the
            children of Israel ate: cucumber and garlic in Egypt{" "}
            <b>(Num. 11:5)</b>
            (likened to milk); manna in the wilderness <b>(Deut. 8:3)</b>{" "}
            (likened to meat); milk and honey in the Promised Land{" "}
            <b>(Lev. 20:24)</b> (likened to strong meat). For a believer to
            stand a chance of becoming incorruptible, he has to be fed with
            milk, meat, and strong meat of the Word <b>(Heb. 5:12-14).</b>
          </Content>
        </Section>
        <br />
        <Section>
          <Title>Milk: The first principles of the oracles of God</Title>

          <Picture src={principles} />
          <SubSection>
            <Content>
              Just as the newly born baby in the natural is first fed with milk,
              to develop the facility for stronger meals, a new born believer is
              first fed the milk <b>(1 Corinthians 3:2).</b> There are six (6)
              principles that the scripture outlines as the basis for milk. They
              are the first principles of the oracles of God or foundation.
              These six (6) principles are the nutrients of the milk.
            </Content>
          </SubSection>
          <SubSection>
            <Content>
              <Subtitle>Repentance from Dead Works</Subtitle>
              Repentance is turning of the soul away from ways, thoughts and
              actions that it previously held/engaged, in response to the light
              of God’s word. These wrong ways, thoughts and actions that
              informed the lifestyle of the believer are called dead works{" "}
              <b>(Hebrews 9:14, 6:1).</b> This principle makes one see that he
              still has a lot of imperfections, and as such, attention should be
              given to the relinquishing of the nature of sin in the soul. This
              principle was heavily emphasized in the early church{" "}
              <b>(Acts 2:38, 3:19).</b> It makes you know that you should not be
              comfortable with sins, and as such, desire to be continually
              cleansed from them by feeding and obedience.
            </Content>
          </SubSection>
          <SubSection>
            <Content>
              <Subtitle>Faith towards God</Subtitle>
              The lowest expression of this doctrine teaches a believer to trust
              God for natural things <b>(Mark 11:24).</b> Much more, this
              doctrine teaches believers to trust God with their lives and God’s
              word instead of their own intelligence or strength and wait
              patiently for him <b>(Prov. 3:5-6).</b> This teaching cultures a
              heart that can trust the invisible for his or her natural affairs{" "}
              <b>(Heb. 11:1).</b>
            </Content>
          </SubSection>
          <SubSection>
            <Content>
              <Subtitle>Doctrine of Baptisms</Subtitle>
              This principle cultures an attitude in a believer that can quickly
              drop previous knowledge for higher knowledge. An attitude that is
              not rigid with what you have known. There are different levels in
              our walk with the Lord. It gives the knowledge that there are
              seasons in God and that, as believers, we have to journey into
              them. It teaches the believer that God deals with us in seasons,
              and that we have to be able to cross from one season to another.
              It instills in the soul a desire to go far in God; a knowing that
              God is more than what I currently know <b>(Phil. 3:12-14).</b>
            </Content>
          </SubSection>
          <SubSection>
            <Content>
              <Subtitle>Laying on of Hands</Subtitle>
              This principle is not just an activity, but it causes a soul to
              recognize that there are believers who are ahead of him in their
              walk with God; he should thus always be under authority. It makes
              the soul see that the less is blessed of the greater{" "}
              <b>(Heb. 7:7).</b> It teaches the soul to discern, honor, and
              submit to spiritual authorities. This teaching is to produce a
              culture of heart which every believer must imbibe all through his
              walk <b>(Heb.12:1-3, 1 Cor.11:1).</b> A believer who submits to
              them that have gone ahead is practicing this doctrine. This
              doctrine was practiced by our Lord Jesus{" "}
              <b>(Matt.3:13-15, 17:1-3, Mark 9:2-4, Luke 9:28-31)</b> and
              Apostle Paul <b>(Acts 9:10-19, Gal.1:15-19, 2:1-2).</b>
            </Content>
          </SubSection>
          <SubSection>
            <Content>
              <Subtitle>Resurrection of the Dead</Subtitle>
              Resurrection of the dead is the change of the bodies of the
              believers into a glorious body during the rapture. This is the
              final redemption of the body <b>
                (Phil. 3:21, 1 Cor. 15:49-53).
              </b>{" "}
              For unbelievers it would be a resurrection unto eternal damnation
              <b>(Dan.12:2).</b> This principle teaches that a day will come
              when we would all be raised again. It gives the soul a belief/hope
              to know that it will rise again after physical death.
            </Content>
          </SubSection>
          <SubSection>
            <Content>
              <Subtitle>Eternal Judgment</Subtitle>
              It instills a sense of knowing that we are going to give account
              for everything we do while on earth. So, we ought not to live as
              we please. It makes us accountable for what we do. It makes us
              realize that our lives do not begin and end with us; that what we
              do is being recorded and we would account for them{" "}
              <b>(2 Cor. 5:10).</b> It causes the believer to be conscious of
              God even when alone, not to live after the flesh but after the
              Spirit <b>(Rom. 8:1,13).</b>
            </Content>
            <Content>
              There are some teachings that we can teach in the milk that might
              not be explicitly spelt out in the six (6) principles but can be
              classified as milk teachings. <br />
              For instance, prayer, the anointing, and gifts of the Spirits; for
              it to be a healthy milk teaching, there must be at least one right
              proportion of the six (6) principles that must be found in the
              teaching. All the six (6) principles in the milk in the right
              proportion can be found in Papa Hagin’s teachings. You can have a
              lot of repentance from dead works, but if you don't have a good
              proportion of faith towards God, your repentance from dead works
              can lead to condemnation. This shows that we need to be fed
              by/receive all the principles of the milk.
            </Content>
          </SubSection>
        </Section>
        <br />
        <Section>
          <Title>The fruit of the milk in the soul</Title>
          <br />
          <Picture src={fruit} />
          <br />
          <br />
          <Content>
            The use of the milk produces two major fruits in the soul of the
            believer, which are, faith in the Lord Jesus and love unto all the
            saints <b>(Ephesians 1:15).</b> These fruits are heart nature
            obtained by the hearing and obedience of the milk allocation of the
            word. The fruit of faith is demonstrated by the unwavering
            dependence and confidence in the Lord Jesus both in seasons of
            goodness and trouble <b>(Acts 4:21, Acts 9:1).</b>
            <br />
            <br />
            Love unto all saints is demonstrated by discerning all believers and
            identifying with them as members of the same body – the body of
            Christ. It is also expressed in one’s ability to part with earthly
            goods in response to a need of a fellow believer. Other fruits that
            are borne by the use of milk are wisdom and honesty in handling
            affairs of this life, and a lifestyle that is subject to the leading
            of the Holy Ghost.
          </Content>
        </Section>
        <br />
        <Section>
          <Title>Limitations of the milk.</Title>

          <Picture src={limitations} />
          <Content>
            The milk is a very important and fundamental allocation of the word
            which every believer must take in. However, the use of milk in
            itself, is not potent to deal with corruption or deliver a believer
            from corruption. It can only limit the corruption taking place in
            the soul and also prepare the believer for a higher allocation of
            the word. In the early church at Jerusalem, all the believers
            gathered together partook of the apostles’ doctrine/milk. A good
            number of the believers at the early church profited with the milk
            examples includes the seven deacons (Stephen, Phillip, Nicanor,
            Nicolas, Prochorus, Timon, and Parmenas) and Barnabas,{" "}
            <b>(Acts 4:8, Acts 6:5, Acts 4:34-37, Acts 11:22-24).</b>
            <br />
            <br />
            However, a careful look at the account of the early church in the
            book of Acts shows that despite the prosperity of the apostles’
            doctrine, certain infirmities of the soul of the people were
            revealed in the process of time. Some examples to justify this
            statement includes Peter’s segregation between the Jews and the
            Gentiles, <b>(Acts 10:13-16, Gal 2:11-14).</b>
            <br />
            <br />
            In addition, the Ephesian church who though they had the fruits of
            the milk were still blind or still had darkened understanding, as
            the apostle Paul still had to pray for the eyes of their
            understanding be enlightened, <b>(Acts 19:20, Eph 1:15-22).</b> The
            presence of these infirmities despite the dispensation of the
            apostles’ doctrine, shows that the milk is limited in handling was
            present in the soul at that time, hence the need for higher
            allocations of the word with the ability to deal with corruption
            that the milk cannot handle.
          </Content>
        </Section>
      </Section>
      <Section>
        <SubSection>
          <Title>Conclusion</Title>
          <Content>
            As we have earlier established that the means through which God
            would raise to himself an incorruptible church or generation is by
            feeding; and having seen the limitation of the milk and its
            inability to make a soul incorruptible, it is necessary to go on to
            the next allocation of the meal provision for the church, this we
            would do in our next lesson.
          </Content>
        </SubSection>
      </Section>
      <WithLove />
    </>
  );
}
